<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1752_1012)">
      <path
        d="M7.00017 0.583496C5.73107 0.583496 4.49047 0.959827 3.43526 1.6649C2.38004 2.36997 1.5576 3.37212 1.07194 4.54461C0.586276 5.7171 0.459205 7.00728 0.706793 8.25199C0.954382 9.4967 1.56551 10.64 2.4629 11.5374C3.36028 12.4348 4.50362 13.0459 5.74834 13.2935C6.99305 13.5411 8.28323 13.4141 9.45572 12.9284C10.6282 12.4427 11.6304 11.6203 12.3354 10.5651C13.0405 9.50986 13.4168 8.26926 13.4168 7.00016C13.4168 5.29836 12.7408 3.66625 11.5374 2.46289C10.3341 1.25954 8.70197 0.583496 7.00017 0.583496ZM9.74592 8.92108C9.80163 8.97489 9.84607 9.03926 9.87664 9.11043C9.90721 9.1816 9.92331 9.25814 9.92398 9.3356C9.92465 9.41305 9.90989 9.48986 9.88056 9.56155C9.85123 9.63324 9.80792 9.69837 9.75315 9.75314C9.69837 9.80791 9.63324 9.85123 9.56155 9.88056C9.48987 9.90989 9.41305 9.92465 9.3356 9.92398C9.25814 9.9233 9.1816 9.90721 9.11043 9.87664C9.03926 9.84607 8.97489 9.80163 8.92108 9.74591L7.00017 7.825L5.07925 9.74591C5.02544 9.80163 4.96107 9.84607 4.8899 9.87664C4.81873 9.90721 4.74219 9.9233 4.66473 9.92398C4.58728 9.92465 4.51047 9.90989 4.43878 9.88056C4.36709 9.85123 4.30196 9.80791 4.24718 9.75314C4.19241 9.69837 4.1491 9.63324 4.11977 9.56155C4.09044 9.48986 4.07568 9.41305 4.07635 9.3356C4.07703 9.25814 4.09312 9.1816 4.12369 9.11043C4.15426 9.03926 4.1987 8.97489 4.25442 8.92108L6.17533 7.00016L4.25442 5.07925C4.1987 5.02544 4.15426 4.96107 4.12369 4.8899C4.09312 4.81873 4.07703 4.74219 4.07635 4.66473C4.07568 4.58728 4.09044 4.51046 4.11977 4.43877C4.1491 4.36708 4.19241 4.30195 4.24718 4.24718C4.30196 4.19241 4.36709 4.1491 4.43878 4.11977C4.51047 4.09044 4.58728 4.07568 4.66473 4.07635C4.74219 4.07702 4.81873 4.09312 4.8899 4.12369C4.96107 4.15426 5.02544 4.1987 5.07925 4.25441L7.00017 6.17533L8.92108 4.25441C8.97489 4.1987 9.03926 4.15426 9.11043 4.12369C9.1816 4.09312 9.25814 4.07702 9.3356 4.07635C9.41305 4.07568 9.48987 4.09044 9.56155 4.11977C9.63324 4.1491 9.69837 4.19241 9.75315 4.24718C9.80792 4.30195 9.85123 4.36708 9.88056 4.43877C9.90989 4.51046 9.92465 4.58728 9.92398 4.66473C9.92331 4.74219 9.90721 4.81873 9.87664 4.8899C9.84607 4.96107 9.80163 5.02544 9.74592 5.07925L7.825 7.00016L9.74592 8.92108Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1752_1012">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
};
</script>
